import {useTranslation} from 'react-i18next'
import {ExportActionButtons} from '@/components/export-action-buttons'
import {useExportActions} from '@/hooks/common/use-export-actions'
import {api, downloadBlob} from '@/lib/api'

async function downloadIpevrExcel(businessId: string): Promise<void> {
  await downloadBlob(`/businesses/${businessId}/sgsst/matriz-riesgos/export.xlsx`, 'matriz-riesgos.xlsx')
}

/** Blob URL because a plain `window.open` on the API URL would not carry the Authorization header. */
async function openIpevrPrint(businessId: string): Promise<void> {
  const resp = await api.get<string>(`/businesses/${businessId}/sgsst/matriz-riesgos/print`, {responseType: 'text'})
  const blob = new Blob([resp.data], {type: 'text/html'})
  const url = URL.createObjectURL(blob)
  window.open(url, '_blank', 'noopener')
}

export function IpevrExportButtons({businessId}: {businessId: string}) {
  const {t} = useTranslation()
  const {pending, error, handleExcel, handlePrint} = useExportActions(
    () => downloadIpevrExcel(businessId),
    () => openIpevrPrint(businessId)
  )

  return (
    <ExportActionButtons
      testidPrefix="ipevr"
      excelLabel={t('ipevrExport.downloadExcel')}
      printLabel={t('ipevrExport.openPrint')}
      pending={pending}
      error={error}
      onExcel={handleExcel}
      onPrint={handlePrint}
    />
  )
}
